<template>
  <div class="main-container">
      <StartPage v-if="store.showStartPage" />
      <SliderPage v-if="store.showSliderPage" />
  </div>
</template>

<script>
import './style/resets.css'
import './style/vars.css'
import './style/animations.css'

import { store } from './store.js'

import StartPage from './pages/StartPage.vue'
import SliderPage from './pages/SliderPage.vue'

export default {
  name: 'App',
  data() {
    return {
      store
    }
  },
  components: {
    StartPage,
    SliderPage
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style>
html {
  overflow: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;

  width: 100vw;
  height: 100vh;
  /* max-width: 1920px;
  max-height: 1080px; */
  background: var(--purple);
  overflow: hidden;
}

.main-container {
  width: 100%;
  height: 100%;
}
</style>
